import { useSearchParams } from 'react-router';
import { SEARCH_PARAM_TYPE_MAPPING, SearchParam, SearchParamTypeMapType } from '../param';

type SearchParamObject<T extends SearchParam[]> = {
  [key in T[number]]: SearchParamTypeMapType[key] extends 'string[]'
    ? string[]
    : SearchParamTypeMapType[key] extends 'number'
      ? number | null
      : string | null;
};

const parseStringArrayToSingularNumber = (rawValue: string[]): number | null => {
  if (rawValue.length === 0) {
    return null;
  }
  const value = parseInt(rawValue[0], 10);
  return isNaN(value) ? null : value;
};

export const useSearchParam = <T extends SearchParam[]>(params: T): SearchParamObject<T> => {
  const [searchParams] = useSearchParams();
  const result = {} as SearchParamObject<T>;

  for (const param of params) {
    const type = SEARCH_PARAM_TYPE_MAPPING[param];
    const rawValue = searchParams.getAll(param);
    let value = null;

    switch (type) {
      case 'string':
        value = rawValue[0] ?? null;
        break;
      case 'string[]':
        value = rawValue;
        break;
      case 'number':
        value = parseStringArrayToSingularNumber(rawValue);
        break;
    }

    // Accept simple handling as extra effort for apparent type safety outweighs the cost
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    result[param] = value;
  }

  return result;
};
